import { useState } from 'react';

import LocalMenu from '@/components/local-menu';
import Metadata from '@/components/metadata';
import Filter from '@/components/stories/filter';
import Grid from '@/components/stories/grid';
import IndexHero from '@/components/stories/index-hero';
import Pagination from '@/components/stories/pagination';
import { PAGE_SIZE } from '@/lib/datocms/constants';
import { KebabCaseTracker } from '@/lib/utils/kebab-case-tracker';
import { GetServerSidePropsContext } from 'next';

export default function StoriesIndex({ data, tags }: { data: any; tags: string[] }) {
  const initialStories = data?.allStories?.slice(0, PAGE_SIZE) || [];
  const [allStories, setAllStories] = useState(initialStories);
  const [hasMoreStories, setHasMoreStories] = useState((data?.allStories?.length || 0) > PAGE_SIZE);

  return (
    <>
      <Metadata data={data} />
      <LocalMenu />
      <IndexHero data={data?.page} />

      {data?.page?.showFilterButtons && <Filter tags={tags} setter={setAllStories} />}

      <Grid data={allStories} />
      <Pagination
        setStories={setAllStories}
        hasMoreStories={hasMoreStories}
        setHasMoreStories={setHasMoreStories}
      />
    </>
  );
}

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { getStoryIndex, getStoryTags } = await import('@/lib/datocms/story-index');
  const kebabTag = context.query.tag as string;
  const locale = context.locale || 'en';

  const tags = await getStoryTags(locale);

  let actualTag = '';

  if (kebabTag) {
    const tagsTracker = new KebabCaseTracker();
    tagsTracker.addAll(tags);
    const rawTags = tagsTracker.getRawByKebab(kebabTag);
    actualTag = rawTags[0] || '';
  }

  const data = await getStoryIndex(locale, actualTag);

  return {
    props: { data, tags },
  };
}
